module.exports = __webpack_public_path__ + "img/user.32200969.svg";